import React from "react";
import "@/styles/company-check.css";

/** "2 of 3 documents in" — the real count of documents with a file of their own, never an estimate.
 *  variant: "full" (case page), "mini" (list rows), "dark" (the client's upload page). */
export function DocsProgress({ progress, variant = "full", testId = "docs-progress" }) {
  if (!progress?.total) return null;
  const { in: got, total } = progress;
  const done = got >= total;
  const pct = Math.round((Math.min(got, total) / total) * 100);
  const left = total - got;
  const bar = <span className="docbar-t" role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={got}><i style={{ width: `${pct}%` }} /></span>;
  if (variant === "mini" || variant === "inline") {
    return (
      <span className={`docbar-mini${variant === "inline" ? " is-inline" : ""}${done ? " is-done" : ""}`} data-testid={testId}
            title={done ? "Every document asked for is in" : `${left} document${left === 1 ? "" : "s"} still to come`}>
        {bar}<span data-testid={`${testId}-text`}>{got} of {total} {variant === "inline" ? `document${total === 1 ? "" : "s"} ` : ""}in</span>
      </span>
    );
  }
  return (
    <div className={`docbar${done ? " is-done" : ""}${variant === "dark" ? " docbar-dark" : ""}`} data-testid={testId}>
      <div className="docbar-h">
        <b data-testid={`${testId}-text`}>{done ? `All ${total} document${total === 1 ? "" : "s"} in` : `${got} of ${total} document${total === 1 ? "" : "s"} in`}</b>
        <span>{done ? "Nothing outstanding" : `${left} still to come`}</span>
      </div>
      {bar}
    </div>
  );
}

export default DocsProgress;
